const UTF8_DECODER = new TextDecoder('utf-8');

function readVarint(data, offset) {
  let result = 0;
  let shift = 0;

  while (offset < data.length) {
    const byte = data[offset];
    offset += 1;

    result += (byte & 0x7f) * 2 ** shift;
    if ((byte & 0x80) === 0) return { value: result, offset };

    shift += 7;
    if (shift > 63) break;
  }

  throw new Error('invalid protobuf varint');
}

function skipField(data, offset, wireType) {
  if (wireType === 0) return readVarint(data, offset).offset;
  if (wireType === 1) return offset + 8;
  if (wireType === 2) {
    const { value: ln, offset: nextOffset } = readVarint(data, offset);
    return nextOffset + Number(ln);
  }
  if (wireType === 5) return offset + 4;
  throw new Error(`unsupported wire type ${wireType}`);
}

function parseWordMessage(blob) {
  let text = null;
  let isFinal = null;
  let i = 0;

  while (i < blob.length) {
    const { value: key, offset: nextOffset } = readVarint(blob, i);
    i = nextOffset;
    const fieldNo = Number(key) >> 3;
    const wireType = Number(key) & 0x7;

    if (wireType === 2 && fieldNo === 1) {
      const { value: ln, offset: afterLen } = readVarint(blob, i);
      const len = Number(ln);
      i = afterLen;
      text = UTF8_DECODER.decode(blob.subarray(i, i + len));
      i += len;
      continue;
    }

    if (wireType === 0 && fieldNo === 4) {
      const { value, offset: afterValue } = readVarint(blob, i);
      i = afterValue;
      isFinal = Boolean(Number(value));
      continue;
    }

    i = skipField(blob, i, wireType);
  }

  return { text, isFinal };
}

function parseTextMessage(data) {
  const out = {
    uid: null,
    time: null,
    words: [],
    durationMs: null,
    dataType: null,
    culture: null,
    textTs: null,
  };

  let i = 0;
  while (i < data.length) {
    const { value: key, offset: nextOffset } = readVarint(data, i);
    i = nextOffset;
    const fieldNo = Number(key) >> 3;
    const wireType = Number(key) & 0x7;

    if (wireType === 0 && fieldNo === 4) {
      const { value, offset: afterValue } = readVarint(data, i);
      i = afterValue;
      out.uid = value;
      continue;
    }

    if (wireType === 0 && fieldNo === 6) {
      const { value, offset: afterValue } = readVarint(data, i);
      i = afterValue;
      out.time = value;
      continue;
    }

    if (wireType === 2 && fieldNo === 10) {
      const { value: ln, offset: afterLen } = readVarint(data, i);
      const len = Number(ln);
      i = afterLen;
      const blob = data.subarray(i, i + len);
      i += len;
      const word = parseWordMessage(blob);
      if (word.text) out.words.push(word);
      continue;
    }

    if (wireType === 0 && fieldNo === 12) {
      const { value, offset: afterValue } = readVarint(data, i);
      i = afterValue;
      out.durationMs = value;
      continue;
    }

    if (wireType === 2 && fieldNo === 13) {
      const { value: ln, offset: afterLen } = readVarint(data, i);
      const len = Number(ln);
      i = afterLen;
      out.dataType = UTF8_DECODER.decode(data.subarray(i, i + len));
      i += len;
      continue;
    }

    if (wireType === 2 && fieldNo === 15) {
      const { value: ln, offset: afterLen } = readVarint(data, i);
      const len = Number(ln);
      i = afterLen;
      out.culture = UTF8_DECODER.decode(data.subarray(i, i + len));
      i += len;
      continue;
    }

    if (wireType === 0 && fieldNo === 16) {
      const { value, offset: afterValue } = readVarint(data, i);
      i = afterValue;
      out.textTs = value;
      continue;
    }

    i = skipField(data, i, wireType);
  }

  return out;
}

/**
 * Decode Agora Real-Time STT protobuf payload from `stream-message`.
 * @param {Uint8Array|ArrayBuffer} uint8ArrayOrBuffer
 * @returns {{ ok: true, data: object, error: null } | { ok: false, data: null, error: Error }}
 */
export function decodeSttPayload(uint8ArrayOrBuffer) {
  try {
    if (uint8ArrayOrBuffer === null) {
      return { ok: false, data: null, error: new Error('empty payload') };
    }
    const buf =
      uint8ArrayOrBuffer instanceof Uint8Array
        ? uint8ArrayOrBuffer
        : new Uint8Array(uint8ArrayOrBuffer);
    if (!buf.length) {
      return { ok: false, data: null, error: new Error('empty payload') };
    }
    const data = parseTextMessage(buf);
    return { ok: true, data, error: null };
  } catch (error) {
    return { ok: false, data: null, error };
  }
}
